<template>
  <section class="agenda">
    <div class="agenda__content container">
      <div class="agenda__date">
        <div class="date__container">
          <div>
            <h1 class="date__title">
              Tuesday, Nov 18th
            </h1>
          </div>
          <button class="rotate-btn" v-bind:class="{ 'is-rotated': isRotated, 'iphone-btn': isIphone }"
          @click="seccionVisible = !seccionVisible" v-on:click="toggleRotation">
            <svg :class="{ 'iphone': isIphone }" width="14px" height="9px" viewBox="0 0 18 11">
              <path fill="#3AADCC" d="M9.1,7.8l6.6-6.6C15.8,1.1,16,1,16.1,0.9c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.5,0.1c0.2,0.1,0.3,0.2,0.4,0.3
              s0.2,0.3,0.3,0.4C18,1.8,18,2,18,2.2s0,0.4-0.1,0.5c-0.1,0.2-0.2,0.3-0.3,0.4l-7.5,7.5C9.8,10.8,9.5,11,9.2,11
              c-0.4,0-0.7-0.1-0.9-0.4L0.8,3.1C0.7,3,0.6,2.8,0.5,2.7C0.3,2.5,0.2,2.4,0.2,2.2c0-0.2,0-0.4,0.1-0.5c0.1-0.2,0.2-0.3,0.3-0.4
              S0.9,1.1,1,1c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4,0,0.5,0.1C2.3,1,2.4,1.1,2.5,1.2L9.1,7.8z"/>
            </svg>
          </button>
        </div>
        <hr class="date__line">
      </div>
      <transition name="fade">
        <div v-show="seccionVisible">
          <div class="cards__container">
            <div class="cards__single grayblue">
              <p class="cards__title">
                Doors Open
              </p>
              <div class="cards__description">
                <p>12:00 PM</p>
              </div>
            </div>
            <br class="linebrk">
            <div v-for="(speaker, index) in afternoonSet" :key="index" class="cards__single cerulean" :class="speaker.class">
              <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
              <div v-if="speaker.logoClass" :class="'logo-img ' + speaker.logoClass"></div>
              <div v-if="speaker.imgClass" class="circle"></div>
              <div class="cards__speaker">
                <p class="cards__name">{{ speaker.name }}</p>
                <p class="cards__spktitle" v-html="speaker.position"></p>
                <p v-if="speaker.title" class="cards__spktitle" v-html="speaker.title"></p>
              </div>
              <div class="cards__description">
                <p class="time">{{ speaker.time }}</p>
                <p v-if="speaker.location" class="location">{{ speaker.location }}</p>
              </div>
            </div>
          </div>
          <div class="cards__container">
            <div class="cards__single cocktail">
              <p class="cards__title">
                Cocktail Hour
              </p>
              <div class="cards__description">
                <p>6:00 PM - 8:00 PM</p>
              </div>
            </div>
            <div class="cards__single dinner">
              <p class="cards__title">
                DNA Supper Club
              </p>
              <div class="cards__description">
                <p>8:00 PM - 10:00 PM</p>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<style lang="scss">
  @import '@/styles/components/agenda.scss';
</style>

<script>
export default {
  name: 'Day One',
  data() {
    return {
      seccionVisible: true,
      isRotated: false,
      isIphone: false,
      afternoonSet: [
        {
          imgClass: 'miglino',
          name: 'Chris Miglino',
          position: 'Co-Founder, President - DNA',
          title: 'Welcome Keynote',
          time: '12:20 PM - 12:40 PM',
        },
        {
          name: 'Students Panel',
          title: 'Cynthia - Stanford Blockchain<br>Samantha - UPenn<br>Shantikiran - Texas Blockchain<br>Konrad - UWaterloo, Co-President of Waterloo Blockchain',
          time: '12:40 PM - 1:00 PM',
          class: 'noheight panel'
        },
        {
          name: 'Beyond Root Staking: Institutional Access to Bittensor Subnets with Charles Barbier',
          title: 'Charles Barbier - Head of Partnerships & Institutional Sales | Bittensor, Mentat Minds',
          time: '1:20 PM - 1:40 PM',
          class: 'noheight panel'
        },
        {
          name: 'Exploring the History of Incentive Mechanism Design',
          title: 'Jake Bargar - Team Rizzo / DNA',
          time: '1:40 PM - 2:00 PM',
          class: 'noheight panel'
        },
        {
          name: 'Lightning Talks: 5 min Presentations',
          time: '2:00 PM - 2:40 PM',
          class: 'noheight panel'
        },
        {
          name: "RESI Presentation Industrial Services, Powered by Bittensor",
          title: 'Seby Rubino',
          time: '2:40 PM - 3:00 PM',
          class: 'noheight panel'
        },
        {
          logoClass: 'omron',
          name: 'Presentation: Omron',
          title: 'Ron Chan',
          time: '3:00 PM - 3:20 PM',
          class: 'logo'
        },
        {
          logoClass: 'bancor',
          name: 'Presentation: Bancor',
          title: 'Mark Richardson, Project Lead',
          time: '3:20 PM - 3:40 PM',
          class: 'logo'
        },
        {
          name: 'DNA Presents: Joe Ross talks with MatterFi / American Fortress',
          title: 'Interviewer: Joe Ross - DNA<br>Michal “Mehow” Pospieszalski - MatterFi / American Fortress',
          time: '3:40 PM - 4:00 PM',
          class: 'noheight panel'
        },
        {
          name: 'Fireside Chat: Bridging TradFi and Web3: The Rise of Digital Asset Treasuries (DATs)',
          title: 'Chris Miglino - DNA <br>Mario Altenburger<br>Max Rebol',
          time: '4:00 PM - 4:20 PM',
          class: 'noheight panel'
        },
        {
          name: 'Panel: Securing the Internet of Value with Naoris Protocol',
          title: 'Panel Moderator: Joe Ross - DNA<br>Maria Lobanova - Naoris Protocol<br>Youssef El Maddarsi - Naoris Protocol',
          time: '4:20 PM - 4:40 PM',
          class: 'noheight panel'
        },
        {
          name: 'DNA Presents: Joe Ross talks with Kredete',
          title: 'Joe Ross - DNA<br>Adeola Adewewe - Kredete',
          time: '4:40 PM - 5:00 PM',
          class: 'noheight panel'
        },
        {
          logoClass: 'climate',
          name: 'Presentation: ClimateTrade',
          title: 'Francisco Benedito Valentin, CEO',
          time: '5:00 PM - 5:20 PM',
          class: 'logo'
        },
        {
          logoClass: 'bittensor',
          name: 'Workshop: Bittensor',
          time: '5:20 PM - 6:00 PM',
          class: 'logo'
        },
        {
          name: 'Presentation: Talisman',
          title: 'Greg Nickolson - Team Rizzo',
          time: '6:00 PM - 6:20 PM',
          class: 'noheight panel'
        }
      ]
    }
  },
  methods: {
    toggleRotation() {
      this.isRotated = !this.isRotated;
    },
  },
  mounted() {
    this.isIphone = /iPhone/.test(navigator.userAgent);
  }
};
</script>
